module.exports = __webpack_public_path__ + "media/images/emblems/Trachselwald-coat_of_arms-c5052542a1d4489378b46e459bbc52da.svg";